import {request} from "../_helpers";

export const platformTypes = {
    namespaced: true,
    state() { return {
        platformTypes: []
    }},
    getters: {
        current: state => id => {
            const result = state.platformTypes.filter(platformType => {
                return platformType.id === parseInt(id);
            });
            return (result) ? result[0] : null;
        },
        allPlatformTypes: state => {
            return state.platformTypes;
        }
    },
    actions: {
        all({commit}) {
            return new Promise((resolve) => {
                request(`${process.env.VUE_APP_WN}/container_platform_type`, 'get')
                    .then(response => {
                        commit('all', response.data);
                        resolve(response)
                    })
            })
        },
    },
    mutations: {
        all(state, all) {
            state.platformTypes = all;
            state.platformTypes.sort((a, b) => {
                let keyA = parseInt(a.id);
                let keyB = parseInt(b.id);
                if(keyA < keyB) return -1;
                if(keyA > keyB) return 1;
                return 0;
            })
        },
    }
}
